module.exports = __webpack_public_path__ + "static/design2020-d7c7e6217ad10fb8fe7ad73e7fbea0aa.jpg";